import { useContext } from 'react'
import { AxiosInstance } from 'axios'
import { Rxios } from 'rxios'
import { AppStateContext } from './AppStateContext'

interface RestResult {
  rest: AxiosInstance
  rxios: Rxios
  rxiosUpload: Rxios
  rxiosGeneral: Rxios
}

export const useRest: () => RestResult = () => {
  const { restClient, rxiosUploadFile, rxiosClient, rxiosGeneralClient } = useContext(AppStateContext)
  const rest = restClient
  const rxios = rxiosClient
  const rxiosUpload = rxiosUploadFile
  const rxiosGeneral = rxiosGeneralClient
  return {
    rest,
    rxios,
    rxiosUpload,
    rxiosGeneral,
  }
}
